<template>
  <div>
    {{scramble}}<br/>
    {{solverOrder}}<br/>
    {{solverStates}}<br/>
    {{currSolver}}<br/>
    <solver v-for='(solver, i) in solversList' :key='i' :inputEnabled='profileID === solver.ID' :solverName='solver.ID.toString()' :state='solverStates[solver.ID]' :tickDown='currSolver === solver.index && started && solverStates[solver.ID].result === null' />
    <v-btn @click='startSession'>START SESSION</v-btn>
  </div>
</template>

<script>
import io from 'socket.io-client'
import AdminService from '@/services/TPC/AdminService'
import FMCService from '@/services/FMCService'

import Solver from '@/components/FMC/Session/Solver'

export default {
  name: 'fmc-session-base',
  components: {
    Solver,
  },
  data () {
    return {
      scramble: '',
      solverOrder: [],
      solverStates: {},
      currSolver: 0,
      started: false,
    }
  },
  methods: {
    async startSession () {
      const {data} = await FMCService.startSession({
        sessionID: this.sessionID,
      })

      if (data.error) {
        alert(`Error: ${data.error} - ${data.message}`) // NOTE: don't alert since that might mess up their timing... just eat the input
      }
    },
    addNewFMCSolver (profileID, state) {
      this.solverStates[profileID] = state
      this.solverOrder.push(profileID)
    },
    receivedMove (profileID, data) {
      this.solverStates[profileID].timeRemaining = data.timeRemaining

      if (data.move !== undefined) this.solverStates[profileID].moves.push(data.move)
      if (data.currSolver !== undefined) this.currSolver = data.currSolver
    },
    async receivedResult (profileID, data) {
      this.solverStates[profileID].result = data.winner
      if (data.winner === true) {
        this.started = false
        alert(`Finished. ${data.profileID} won!`)
        return
      }
      
      // Check if this solver won
      let remaining = Object.entries(this.solverStates).filter(([, v]) => (v.result === null))
      if (remaining.length === 1 && parseInt(remaining[0][0]) === this.profileID) {
        const {data} = await FMCService.submitResult({
          sessionID: this.sessionID,
          winner: true,
          resultType: 'lastRemaining',
        })

        if (data.error) {
          alert(`Error: ${data.error} - ${data.message}`)
        }
      }
    },
  },
  computed: {
    sessionID () {
      return this.$route.params.sid
    },
    profileID () {
      return this.$store.state.loginSettings.profileID
    },
    solversList () {
      if (this.solverOrder.length === 0) return []
      let solversList = this.solverOrder.map((v, i) => ({ID: v, index: i}))
      let solverPos = 0
      for (let i = 0; i < this.solverOrder.length; i++) {
        if (this.profileID === this.solverOrder[i]) {
          solverPos = i
          break
        }
      }
      return [solversList[solverPos]].concat(solversList.slice(0, solverPos)).concat(solversList.slice(solverPos + 1))
    }
  },
  async created () {
    if (this.$store.state.loginSettings.loggedIn !== undefined) return
    let resp = await AdminService.verifyAdmin()
    this.$store.commit('setLoginSettings', {
      loggedIn: (resp.data && resp.data.error !== 'notAuthenticated'),
      adminAvailable: (resp.data && resp.data.success),
      profileID: (resp.data && resp.data.profileID),
    })

    this.$store.commit('setSessionId', this.sessionID)
    this.$store.commit('setSolverId', this.profileID)

    this.$store.state.socket = io.connect(this.$backendHost, {
      query: {
        connectionType: 'fmc',
        profileID: this.profileID,
        sessionID: this.sessionID,
      }
    })

    this.$store.state.socket.on('ehlo', async (data) => {
      this.solverStates = data.solverStates
      this.solverOrder = data.solverOrder
      this.scramble = data.scramble
      this.currSolver = data.currSolver
      this.started = data.started === 1 ? true : false
    })

    this.$store.state.socket.on('newFMCSolver', (data) => {
      this.addNewFMCSolver(data.profileID, data.state)
    })
    this.$store.state.socket.on('fmcStarted', () => {
      this.started = true
      this.currSolver = 0
    })
    this.$store.state.socket.on('fmcSubmit', (data) => {
      this.receivedMove(data.profileID, data)
    })
    this.$store.state.socket.on('fmcResult', (data) => {
      this.receivedResult(data.profileID, data)
    })
  }
}
</script>
